import { IS_MOCK_INIT_SECTIONS_ENABLED } from '../constants/rentalPortalMock'
import { ROUTE_UI_SECTION_NAME_RENTAL_PORTAL } from '../constants/route'

import { hasRentalPortalMockCreateRight } from './rentalPortalMockState'

// TODO: confirm the RP section key spellings served by init
function getRentalPortalSectionPermissionsByName() {
  const canCreate = hasRentalPortalMockCreateRight()

  return {
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.applicants]: {
      permissions: { can_create: canCreate, can_view: true },
    },
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.archive]: {
      permissions: { can_create: false, can_view: true },
    },
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.contracts]: {
      permissions: { can_create: false, can_view: true },
    },
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.listings]: {
      permissions: { can_create: canCreate, can_view: true },
    },
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.overview]: {
      permissions: { can_create: false, can_view: true },
    },
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.root]: {
      permissions: { can_create: false, can_view: true },
    },
    [ROUTE_UI_SECTION_NAME_RENTAL_PORTAL.viewings]: {
      permissions: { can_create: false, can_view: true },
    },
  }
}

export function withRentalPortalMockSections(sections) {
  return IS_MOCK_INIT_SECTIONS_ENABLED
    ? { ...getRentalPortalSectionPermissionsByName(), ...sections }
    : sections
}
